import React from "react";
import { Button } from "react-bootstrap";
import { CourceSlider } from "../Badges/Views/CourceSlider";

export const QuizzerCard = (props) => {

    return (
        <>

            {

                props.status == "in-progress" ?

                    <div className={props.warningBg ? 'sb-qiz-card sb-qc-ip sb-wrn' : 'sb-qiz-card sb-qc-ip'} >

                        <img src={props.image} />
                        <div className="sb-qiz-card__content">
                            <h4>{props.title}</h4>
                            <p>{props.description} </p>


                            <div className="sb-quiz-card-content-btns-ip">
                                <Button className="sb-primary-btn--38">View Course</Button>
                                <label> In Progress ... </label>
                            </div>


                        </div>
                    </div>

                    :

                    props.status == "completed" ?
                        <div className={props.warningBg ? 'sb-qiz-card sb-qc-compl sb-wrn' : 'sb-qiz-card sb-qc-compl'} >

                            <img src={props.image} />
                            <div className="sb-qiz-card__content">
                                <h4>{props.title}</h4>
                                <p>{props.description} </p>


                                <div className="sb-quiz-card-content-btns-compl">
                                    <Button className="sb-primary-btn--38">
                                        <span> Completed</span>
                                        <span>12:34 12/10/22</span>
                                    </Button>
                                    <label> View? </label>
                                </div>



                            </div>
                        </div>

                        :
                        props.status == "not-started" ?
                            <div className={props.warningBg ? 'sb-qiz-card sb-qc-not-st sb-wrn' : 'sb-qiz-card sb-qc-not-st'} >

                                <img src={props.image} />
                                <div className="sb-qiz-card__content">
                                    <h4>{props.title}</h4>
                                    <p>{props.description} </p>

                                    <div className="sb-quiz-card-content-btns-ip sb-quiz-card-content-btns-nstarted">
                                        <Button className="sb-primary-btn--38">View Course</Button>
                                        <label> Not Started ... </label>
                                    </div>

                                </div>
                            </div>

                            : ''



            }

            {
                props.expand &&

                <CourceSlider slides={4} />

            }

        </>
    )
}